export enum CalculationFormUserTypeEnum {
  New = 'new', // new user filling out the form for the first time
  Renewal = 'renewal',
  Returning = 'returning', // user returning from the ranking or returning "from cookies"
  Rop = 'rop',
}
